import {Component, OnDestroy, OnInit} from '@angular/core';
import {Question} from '../../../../../models/question.model';
import {StepTestingService} from './step-testing.service';
import {StepsControllerService} from '../../../../../services/steps-controller.service';
import {AdminService} from '../../../../../services/admin.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-step-cteate-testing',
  templateUrl: './step-cteate-testing.component.html',
  styleUrls: ['./step-cteate-testing.component.css']
})
export class StepCteateTestingComponent implements OnInit, OnDestroy {
  disSaveQBtn = false;
  isValidTempStnd = true;
  showSaveBtn = true;

  constructor(public stepTestingService: StepTestingService,
              public stepsControllerService: StepsControllerService,
              public adminService: AdminService,
              private router: Router) {
  }

  ngOnDestroy() {
    this.stepTestingService.clearQuestions();
  }

  ngOnInit() {
    if (this.router.url.includes('/step-eight')) {
      this.showSaveBtn = false;
    } else {
      this.showSaveBtn = true;
    }
  }

  deleteQuestionFromList(key) {
    this.stepTestingService.deleteQuestionFromList(key);
  }

  addQuestionToList() {
    this.stepTestingService.addQuestionToList();
  }

  addQuestionToStandardTemp() {
    this.isValidTempStnd = true;

    // *ngIf="stepsControllerService.getLocalUserLanguage() === 'En'"
    if (this.stepTestingService.isQuestionsValid(this.stepsControllerService.getLocalUserLanguage())) {
      this.disSaveQBtn = true;
      const existQuestions = this.stepTestingService.addQuestionToStandardTemp();

      const questionsForAdding = {
        english: [],
        russian: []
      };

      if (existQuestions.length > 0) {
        existQuestions.forEach(item => {
          const addingQuestionRu = {
            questionText: '',
            answers: [
              {answerText: ''},
              {answerText: ''},
              {answerText: ''}
            ],
            rightAnswer: {answerText: ''}
          };
          const addingQuestionEn = {
            questionText: '',
            answers: [
              {answerText: ''},
              {answerText: ''},
              {answerText: ''}
            ],
            rightAnswer: {answerText: ''}
          };

          // Russian
          addingQuestionRu.questionText = item.questionTextRu;
          addingQuestionRu.answers[0].answerText = item.answers[0].answerOneRu;
          addingQuestionRu.answers[1].answerText = item.answers[0].answerTwoRu;
          addingQuestionRu.answers[2].answerText = item.answers[0].answerThreeRu;

          switch (item.rightAnswerRu) {
            case '1':
              addingQuestionRu.rightAnswer.answerText = item.answers[0].answerOneRu;
              break;
            case '2':
              addingQuestionRu.rightAnswer.answerText = item.answers[0].answerTwoRu;
              break;
            case '3':
              addingQuestionRu.rightAnswer.answerText = item.answers[0].answerThreeRu;
              break;
          }

          questionsForAdding.russian.push(addingQuestionRu);

          // English
          addingQuestionEn.questionText = item.questionTextEn;
          addingQuestionEn.answers[0].answerText = item.answers[0].answerOneEn;
          addingQuestionEn.answers[1].answerText = item.answers[0].answerTwoEn;
          addingQuestionEn.answers[2].answerText = item.answers[0].answerThreeEn;

          switch (item.rightAnswerEn) {
            case '1':
              addingQuestionEn.rightAnswer.answerText = item.answers[0].answerOneEn;
              break;
            case '2':
              addingQuestionEn.rightAnswer.answerText = item.answers[0].answerTwoEn;
              break;
            case '3':
              addingQuestionEn.rightAnswer.answerText = item.answers[0].answerThreeEn;
              break;
          }

          questionsForAdding.english.push(addingQuestionEn);
        });

        // Done
        this.adminService.setTempQuestionsForStandard(this.stepsControllerService.getCurrentStandard().id, questionsForAdding).subscribe(
          (res: any) => {
            this.disSaveQBtn = false;
          },
          () => {
            this.disSaveQBtn = false;
          }
        );
      }
    } else {
      this.isValidTempStnd = false;
    }
  }

  copyQuestion(i) {
    this.stepTestingService.addQuestionToListCopy(i);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/opst-step-six/step-cteate-testing/step-cteate-testing.component.ts